'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import PWAProvider from 'containers/PWAProvider'
import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect'
import BuilderTextContent from 'src/components/BuilderTextContent'
import Loader from 'src/components/Loader'
import { useAppDispatch } from 'src/store/hooks'
import { setTabsConfig } from 'src/store/modules/user/actions'

import Providers from '../Providers'

import type { Provider } from '@patrianna/shared-patrianna-types/store/ProviderModule'

export type Props = {
  providers: Provider[]
  content?: any
  shouldBeRedirected?: boolean
  categories?: string[]
}

export default function ProvidersPageClient({ providers, content, shouldBeRedirected, categories }: Props) {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const shouldBeRedirectedToDefaultPage = providers.length === 0 || shouldBeRedirected

  useEffect(() => {
    if (shouldBeRedirectedToDefaultPage) {
      router.push('/slots')
    }
    // eslint-disable-next-line
  }, [])

  useIsomorphicLayoutEffect(() => {
    if (categories) {
      dispatch(setTabsConfig({ tabsConfig: { categories, shouldBeRedirected } }))
    }
  }, [categories, dispatch, shouldBeRedirected])

  if (shouldBeRedirectedToDefaultPage) {
    return <Loader fullscreen />
  }

  return (
    <>
      <Providers providers={providers} />
      {content && <BuilderTextContent content={content} model={process.env.PROVIDERS_DESCRIPTION} />}
      <PWAProvider />
    </>
  )
}
